import modules, { Dashboard, providers, title } from "@/app.default"

import {
  Admin,
  ForgotPasswordPage,
  ResetPasswordPage,
} from "@/components/admin"
// import { LoginPage } from '@/packages/raf/components'

import { Authenticated, CustomRoutes, Resource } from "ra-core"
import { lazy, ReactElement, useEffect } from "react"
import { Route } from "react-router"
// import { baseProps } from '@/packages/raf'

const ProfilePage = lazy(
  () => import("./modules/users/components/account-settings")
)

const App = (): ReactElement => {
  useEffect(() => {
    document.title = title
  }, [])

  return (
    <Admin
      title={title}
      {...(providers as unknown as any)}
      dashboard={Dashboard}
      requireAuth
      disableTelemetry
    >
      {permissions => {
        const userPermissions = (permissions || {}) as Record<string, string[]>
        return Object.values(modules).map(m => (
          <Resource {...m(userPermissions)} key={m.name} />
        ))
      }}

      <CustomRoutes noLayout>
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
      </CustomRoutes>

      <CustomRoutes>
        <Route
          path="/settings"
          element={
            <Authenticated>
              <ProfilePage />
            </Authenticated>
          }
        />
      </CustomRoutes>
    </Admin>
  )
}

export default App
